module.exports = __webpack_public_path__ + "img/135x90-01.232e10c8.png";